/* istanbul ignore file */
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { InvoiceTotalField } from 'domain/shared/core/invoice';
import { useSensitiveDataContext } from 'framework/sensitiveData';

const ReconciliationAmountField = ({ source, idSource, ...props }: FieldProps) => {
  const sensitiveDataContext = useSensitiveDataContext();
  const { getValue } = useFieldHelper({ source: idSource });
  const amount = sensitiveDataContext.getValueByIdAndSource(source, getValue()) || 0;

  return (
    <InvoiceTotalField
      {...props}
      source={source}
      currencySource="currency"
      formatCurrency={() => 'USD'}
      formatAmount={() => amount}
    />
  );
};

export default ReconciliationAmountField;
